import { QueryClient } from 'react-query';
import { IOptions, LoginWeb } from 'common/types/common.types';
import { UserInfoWithLzPzus, UserRole } from 'api';
import { ERouteUrl } from 'router/config';
import { history } from './history';

const queryClient = new QueryClient();

export const ROLES_LIST: UserRole[] = [
  UserRole.LzAdmin,
  UserRole.AppAdmin,
  UserRole.PzuCashier,
  UserRole.PzuInspector,
  UserRole.LzAccountant,
  UserRole.AppViewer,
  UserRole.TechSupport,
];

// Если НЕ администратор СП, то значение не показываем
export const permissionFilterOptions = (currentUser: UserInfoWithLzPzus, skip?: UserRole[]) =>
  RolesSelectList(
    ROLES_LIST.filter(
      item => !(item === UserRole.AppAdmin && currentUser.roles[0] !== UserRole.AppAdmin) && !skip?.includes(item),
    ),
  );

export const isRoleGuard = (guardRoles: UserRole[], userRoles: UserRole[]): boolean =>
  userRoles.some(role => guardRoles.includes(role));

export const getValidatedRole = (roles: UserRole[]): UserRole[] | null =>
  roles.some(role => ROLES_LIST.includes(role)) ? roles : null;

export const getRole = (): UserRole[] | null => {
  const roles: string | null = localStorage.getItem('roles');
  if (roles) return getValidatedRole(JSON.parse(roles));
  return null;
};

export const getToken = (): string | null => localStorage.getItem('token');

export const setRoles = (roles: Array<UserRole>): void => localStorage.setItem('roles', JSON.stringify(roles));
export const setToken = (token: string): void => localStorage.setItem('token', token);

export const removeCredentials = (): void => {
  localStorage.removeItem('roles');
  localStorage.removeItem('token');
};

export const roleTranslate = (role: UserRole | undefined) => {
  if (!role) return 'Роль не определена';
  switch (role) {
    case UserRole.AppAdmin:
      return 'Администратор СП';
    case UserRole.LzAdmin:
      return 'Администратор ЛЗ';
    case UserRole.PzuCashier:
      return 'Приёмщик-кассир';
    case UserRole.PzuInspector:
      return 'Приёмщик';
    case UserRole.LzAccountant:
      return 'Бухгалтер';
    case UserRole.AppViewer:
      return 'Сотрудник комплаенс';
    case UserRole.TechSupport:
      return 'Сотрудник техподдержки';
    default:
      return 'Роль не определена';
  }
};

export const isWebAllowedCode = (role: boolean) => {
  if (role === true) {
    return {
      label: 'Разрешено',
      value: LoginWeb.ALLOW,
    };
  }
  return {
    label: 'Запрещено',
    value: LoginWeb.NON_ALLOW,
  };
};

export const isWebAllowedDecode = (obj: IOptions) => {
  switch (obj.value) {
    case LoginWeb.ALLOW:
      return true;
    case LoginWeb.NON_ALLOW:
      return false;
    default:
      return true;
  }
};

export const RolesSelectList = (roles: UserRole[] = ROLES_LIST) => {
  const result: IOptions[] = [];

  roles.forEach(role => {
    result.push({
      label: roleTranslate(role),
      value: role,
    });
  });

  return result;
};

export const getRolesArrFromLabel = (role: string) => ROLES_LIST.filter(item => item === role);

export const rolesRedirect = (user: UserInfoWithLzPzus) => {
  switch (user?.roles[0]) {
    case UserRole.AppAdmin:
      history.push(ERouteUrl.OPERATIONS_PSA_LIST);
      break;
    case UserRole.LzAdmin:
      history.push(ERouteUrl.OPERATIONS_PSA_LIST);
      break;
    case UserRole.PzuCashier:
    case UserRole.PzuInspector:
      history.push(ERouteUrl.OPERATIONS_PSA_LIST);
      break;
    case UserRole.LzAccountant:
      history.push(ERouteUrl.PZU_LIST);
      break;
    case UserRole.AppViewer:
      history.push(ERouteUrl.OPERATIONS_PSA_LIST);
      break;
    case UserRole.TechSupport:
      history.push(ERouteUrl.OPERATIONS_PSA_LIST);
      break;
    default:
      history.push(ERouteUrl.LOGIN);
      break;
  }
};

export const isAppAdmin = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.AppAdmin;
export const isLzAdmin = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.LzAdmin;
export const isCashier = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.PzuCashier;
export const isInspector = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.PzuInspector;
export const isILzAccountant = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.LzAccountant;
export const isAppViewer = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.AppViewer;
export const isTechSupport = (user: UserInfoWithLzPzus) => user?.roles[0] === UserRole.TechSupport;

export const logout = () => {
  removeCredentials();

  history.push(ERouteUrl.LOGIN);

  queryClient.clear();
};
